import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import DOMPurify from "dompurify";

const PageViewer = () => {
  const { filename } = useParams();
  const [html, setHtml] = useState("");
  const [error, setError] = useState("");

  const backendBase = useMemo(
    () => (process.env.REACT_APP_BACKEND_API_URL || "").replace(/\/$/, ""),
    []
  );

  useEffect(() => {
    let isMounted = true;

    const loadHtml = async () => {
      try {
        setError("");
        const safeName = encodeURIComponent(filename || "");
        const response = await fetch(`${backendBase}/pages/${safeName}`);

        if (!response.ok) {
          throw new Error(`Unable to load page (${response.status})`);
        }

        const text = await response.text();
        if (isMounted) {
          setHtml(DOMPurify.sanitize(text, { WHOLE_DOCUMENT: true }));
        }
      } catch (err) {
        if (isMounted) {
          setError("Failed to load page");
        }
      }
    };

    if (filename) {
      loadHtml();
    } else {
      setError("Invalid page path");
    }

    return () => {
      isMounted = false;
    };
  }, [backendBase, filename]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white text-red-600 font-semibold px-4 text-center">
        {error}
      </div>
    );
  }

  if (!html) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white text-[#5e1783] font-semibold">
        Loading page...
      </div>
    );
  }

  const safeName = encodeURIComponent(filename || "");
  const viewerSrc = `${backendBase}/pages/${safeName}`;

  return (
    <iframe
      title={filename || "uploaded-page"}
      src={viewerSrc}
      className="w-full min-h-screen border-0 bg-white"
      sandbox="allow-same-origin allow-forms allow-modals allow-popups allow-scripts"
    />
  );
};

export default PageViewer;
